/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../connect/v2/common/money';
import './external_api_common';
import '../../fees/external/payment_price';
import '../../connect/v2/resources/address';
import './payments_model';
import '../../connect/v2/resources/error';
import '../../connect/v2/common/coordinates';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "connect": {
        "nested": {
          "v2": {
            "nested": {
              "CreatePaymentRequest": {
                "fields": {
                  "sourceId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "cardPresentOptions": {
                    "type": ".squareup.connect.v2.CardPresentOptions",
                    "id": 33,
                    "rule": "optional"
                  },
                  "idempotencyKey": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "amountMoney": {
                    "type": ".squareup.connect.v2.common.Money",
                    "id": 3,
                    "rule": "optional"
                  },
                  "tipMoney": {
                    "type": ".squareup.connect.v2.common.Money",
                    "id": 4,
                    "rule": "optional"
                  },
                  "taxMoney": {
                    "type": ".squareup.connect.v2.common.Money",
                    "id": 19,
                    "rule": "optional"
                  },
                  "cardSurchargeMoney": {
                    "type": ".squareup.connect.v2.common.Money",
                    "id": 62,
                    "rule": "optional"
                  },
                  "appFeeMoney": {
                    "type": ".squareup.connect.v2.common.Money",
                    "id": 5,
                    "rule": "optional"
                  },
                  "appFeeAllocations": {
                    "type": ".squareup.connect.v2.AppFeeAllocation",
                    "id": 70,
                    "rule": "repeated"
                  },
                  "appFeeLocationId": {
                    "type": "string",
                    "id": 46,
                    "rule": "optional"
                  },
                  "paymentFeesSpec": {
                    "type": ".squareup.connect.v2.PaymentFeesSpec",
                    "id": 25,
                    "rule": "optional"
                  },
                  "delayDuration": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "delayAction": {
                    "type": "string",
                    "id": 36,
                    "rule": "optional"
                  },
                  "autocomplete": {
                    "type": "bool",
                    "id": 7,
                    "rule": "optional",
                    "options": {
                      "default": true
                    }
                  },
                  "createOrder": {
                    "type": "bool",
                    "id": 12,
                    "rule": "optional",
                    "options": {
                      "default": true
                    }
                  },
                  "orderId": {
                    "type": "string",
                    "id": 11,
                    "rule": "optional"
                  },
                  "customerId": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "locationId": {
                    "type": "string",
                    "id": 10,
                    "rule": "optional"
                  },
                  "employeeId": {
                    "type": "string",
                    "id": 29,
                    "rule": "optional"
                  },
                  "teamMemberId": {
                    "type": "string",
                    "id": 47,
                    "rule": "optional"
                  },
                  "referenceId": {
                    "type": "string",
                    "id": 13,
                    "rule": "optional"
                  },
                  "verificationToken": {
                    "type": "string",
                    "id": 24,
                    "rule": "optional"
                  },
                  "terminalCheckoutId": {
                    "type": "string",
                    "id": 17,
                    "rule": "optional"
                  },
                  "acceptPartialAuthorization": {
                    "type": "bool",
                    "id": 18,
                    "rule": "optional"
                  },
                  "buyerEmailAddress": {
                    "type": "string",
                    "id": 20,
                    "rule": "optional"
                  },
                  "buyerFirstName": {
                    "type": "string",
                    "id": 60,
                    "rule": "optional"
                  },
                  "buyerLastName": {
                    "type": "string",
                    "id": 61,
                    "rule": "optional"
                  },
                  "buyerPhoneNumber": {
                    "type": "string",
                    "id": 58,
                    "rule": "optional"
                  },
                  "billingAddress": {
                    "type": ".squareup.connect.v2.resources.Address",
                    "id": 21,
                    "rule": "optional"
                  },
                  "shippingAddress": {
                    "type": ".squareup.connect.v2.resources.Address",
                    "id": 22,
                    "rule": "optional"
                  },
                  "note": {
                    "type": "string",
                    "id": 23,
                    "rule": "optional"
                  },
                  "statementDescriptionIdentifier": {
                    "type": "string",
                    "id": 26,
                    "rule": "optional"
                  },
                  "requestedStatementDescription": {
                    "type": "string",
                    "id": 28,
                    "rule": "optional"
                  },
                  "revenueAssociationTags": {
                    "type": "string",
                    "id": 27,
                    "rule": "repeated"
                  },
                  "applicationIdAttribution": {
                    "type": "string",
                    "id": 45,
                    "rule": "optional"
                  },
                  "geoLocation": {
                    "type": ".squareup.connect.v2.GeoLocation",
                    "id": 31,
                    "rule": "optional"
                  },
                  "auxiliaryInfo": {
                    "type": ".squareup.connect.v2.AuxiliaryInfo",
                    "id": 32,
                    "rule": "repeated"
                  },
                  "cashDetails": {
                    "type": ".squareup.connect.v2.CashPaymentDetails",
                    "id": 34,
                    "rule": "optional"
                  },
                  "externalDetails": {
                    "type": ".squareup.connect.v2.ExternalPaymentDetails",
                    "id": 35,
                    "rule": "optional"
                  },
                  "asyncTransactionCreationDetails": {
                    "type": ".squareup.connect.v2.AsyncTransactionCreationDetails",
                    "id": 56,
                    "rule": "optional"
                  },
                  "payinDetails": {
                    "type": ".squareup.connect.v2.CardPayInDetails",
                    "id": 37,
                    "rule": "optional"
                  },
                  "billpayPullDetails": {
                    "type": ".squareup.connect.v2.BillPayPullDetails",
                    "id": 52,
                    "rule": "optional"
                  },
                  "deviceDetails": {
                    "type": ".squareup.connect.v2.DeviceDetails",
                    "id": 41,
                    "rule": "optional"
                  },
                  "squareProduct": {
                    "type": "string",
                    "id": 39,
                    "rule": "optional"
                  },
                  "additionalSquareProductDetails": {
                    "type": ".squareup.connect.v2.AdditionalSquareProductDetails",
                    "id": 63,
                    "rule": "repeated"
                  },
                  "feePlanProduct": {
                    "type": "string",
                    "id": 48,
                    "rule": "optional"
                  },
                  "refundPolicy": {
                    "type": ".squareup.connect.v2.RefundPolicy",
                    "id": 40,
                    "rule": "optional"
                  },
                  "peripheralMetadata": {
                    "type": ".squareup.connect.v2.PeripheralMetadata",
                    "id": 42,
                    "rule": "optional"
                  },
                  "customerDetails": {
                    "type": ".squareup.connect.v2.CustomerDetails",
                    "id": 43,
                    "rule": "optional"
                  },
                  "recurringDetails": {
                    "type": ".squareup.connect.v2.RecurringPaymentDetails",
                    "id": 44,
                    "rule": "optional"
                  },
                  "issuerInstallmentDetails": {
                    "type": ".squareup.connect.v2.IssuerInstallmentDetails",
                    "id": 64,
                    "rule": "optional"
                  },
                  "healthcareDetails": {
                    "type": ".squareup.connect.v2.HealthcareDetails",
                    "id": 54,
                    "rule": "optional"
                  },
                  "requestContextToken": {
                    "type": "string",
                    "id": 49,
                    "rule": "optional"
                  },
                  "isOfflineRequest": {
                    "type": "bool",
                    "id": 51,
                    "rule": "optional"
                  },
                  "isDebtRepayment": {
                    "type": "bool",
                    "id": 53,
                    "rule": "optional"
                  },
                  "usePreauthorization": {
                    "type": "bool",
                    "id": 65,
                    "rule": "optional"
                  },
                  "paymentProposalDetails": {
                    "type": ".squareup.connect.v2.PaymentProposalDetails",
                    "id": 55,
                    "rule": "optional"
                  },
                  "offlinePaymentDetails": {
                    "type": ".squareup.connect.v2.OfflinePaymentDetails",
                    "id": 66,
                    "rule": "optional"
                  },
                  "superPosMetadata": {
                    "type": ".squareup.connect.v2.SuperPosMetadata",
                    "id": 68,
                    "rule": "optional"
                  },
                  "cardDetails": {
                    "type": ".squareup.connect.v2.CardPaymentDetails",
                    "id": 69,
                    "rule": "optional"
                  },
                  "additionalSignals": {
                    "type": ".squareup.connect.v2.Signal",
                    "id": 71,
                    "rule": "repeated"
                  }
                }
              },
              "CreatePaymentResponse": {
                "fields": {
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "payment": {
                    "type": ".squareup.connect.v2.Payment",
                    "id": 2,
                    "rule": "optional"
                  },
                  "encryptedEmvData": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "UpdatePaymentRequest": {
                "fields": {
                  "payment": {
                    "type": ".squareup.connect.v2.Payment",
                    "id": 1,
                    "rule": "optional"
                  },
                  "idempotencyKey": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "paymentId": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "requestContextToken": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "UpdatePaymentResponse": {
                "fields": {
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "payment": {
                    "type": ".squareup.connect.v2.Payment",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "CancelPaymentRequest": {
                "fields": {
                  "paymentId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "CancelPaymentResponse": {
                "fields": {
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "payment": {
                    "type": ".squareup.connect.v2.Payment",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "CancelPaymentByIdempotencyKeyRequest": {
                "fields": {
                  "idempotencyKey": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "CancelPaymentByIdempotencyKeyResponse": {
                "fields": {
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "SetEmvDataRequest": {
                "fields": {
                  "idempotencyKey": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "paymentId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "encryptedEmvData": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "SetEmvDataResponse": {
                "fields": {
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "payment": {
                    "type": ".squareup.connect.v2.Payment",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "CompletePaymentRequest": {
                "fields": {
                  "paymentId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "encryptedEmvData": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "versionToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "isOfflineRequest": {
                    "type": "bool",
                    "id": 4,
                    "rule": "optional"
                  },
                  "completePaymentParamsForOrders": {
                    "type": ".squareup.connect.v2.CompletePaymentParamsForOrders",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              },
              "CompletePaymentResponse": {
                "fields": {
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "payment": {
                    "type": ".squareup.connect.v2.Payment",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "CompletePaymentParamsForOrders": {
                "fields": {
                  "alwaysCompleteOrderOnBalance": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "alwaysCompleteSingleCheckoutPaymentAsPartial": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "GetPaymentRequest": {
                "fields": {
                  "paymentId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "GetPaymentResponse": {
                "fields": {
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "payment": {
                    "type": ".squareup.connect.v2.Payment",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "ListPaymentsRequest": {
                "fields": {
                  "beginTime": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "endTime": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "sortOrder": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "cursor": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "locationId": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "total": {
                    "type": "int64",
                    "id": 7,
                    "rule": "optional"
                  },
                  "last4": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "cardBrand": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "limit": {
                    "type": "int32",
                    "id": 10,
                    "rule": "optional"
                  },
                  "isOfflinePayment": {
                    "type": "bool",
                    "id": 11,
                    "rule": "optional"
                  },
                  "offlineBeginTime": {
                    "type": "string",
                    "id": 12,
                    "rule": "optional"
                  },
                  "offlineEndTime": {
                    "type": "string",
                    "id": 13,
                    "rule": "optional"
                  },
                  "updatedAtBeginTime": {
                    "type": "string",
                    "id": 14,
                    "rule": "optional"
                  },
                  "updatedAtEndTime": {
                    "type": "string",
                    "id": 15,
                    "rule": "optional"
                  },
                  "sortField": {
                    "type": ".squareup.connect.v2.ListPaymentsRequest.SortField",
                    "id": 16,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "SortField": {
                    "values": {
                      "SORT_FIELD_DO_NOT_USE": 0,
                      "CREATED_AT": 1,
                      "OFFLINE_CREATED_AT": 2,
                      "UPDATED_AT": 3
                    }
                  }
                }
              },
              "ListPaymentsResponse": {
                "fields": {
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "payments": {
                    "type": ".squareup.connect.v2.Payment",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "cursor": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "CardPresentOptions": {
                "fields": {
                  "isEmvCapableReaderPresent": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "chipCardFallbackIndicator": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "offlineStoreAndForwardCreatedAt": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "hardwareSerialNumber": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "readerFirmwareVersion": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              },
              "GeoLocation": {
                "fields": {
                  "coordinates": {
                    "type": ".squareup.connect.v2.common.Coordinates",
                    "id": 1,
                    "rule": "optional"
                  },
                  "altitudeMeters": {
                    "type": "double",
                    "id": 2,
                    "rule": "optional"
                  },
                  "uncertaintyMeters": {
                    "type": "double",
                    "id": 3,
                    "rule": "optional"
                  },
                  "geoLocationType": {
                    "type": ".squareup.connect.v2.GeoLocation.GeoLocationType",
                    "id": 4,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "GeoLocationType": {
                    "values": {
                      "GEO_LOCATION_TYPE_DO_NOT_USE": 0,
                      "SQUARE_DEVICE_ACCESS_POINT": 1,
                      "SQUARE_DEVICE_ETHERNET_GEOIP": 2
                    }
                  }
                }
              },
              "AuxiliaryInfo": {
                "fields": {
                  "key": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "value": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "CardPayInDetails": {
                "fields": {
                  "destinationUnitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "depositToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "balanceToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "overrideMessageType": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "overrideCategoryCode": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "overrideProductSubCategory": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "overridePayWithSquareEntryMethod": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "skipWalletReconciliation": {
                    "type": "bool",
                    "id": 8,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  }
                }
              },
              "BillPayPullDetails": {
                "fields": {
                  "billpayUnitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "overrideCategoryCode": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "overridePayWithSquareEntryMethod": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "overrideMessageType": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "overrideProductSubCategory": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "billpayId": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "billPayRecipientDetails": {
                    "type": ".squareup.connect.v2.BillPayRecipientDetails",
                    "id": 7,
                    "rule": "optional"
                  }
                }
              },
              "BillPayRecipientDetails": {
                "fields": {
                  "recipientId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "name": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "address": {
                    "type": ".squareup.connect.v2.resources.Address",
                    "id": 3,
                    "rule": "optional"
                  },
                  "emailAddress": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "phoneNumber": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "mcc": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  }
                }
              },
              "PeripheralMetadata": {
                "fields": {
                  "appRelease": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "appVersion": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "sourceDeviceInstallationId": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "connectedPeripherals": {
                    "type": ".squareup.connect.v2.ConnectedPeripheral",
                    "id": 4,
                    "rule": "repeated"
                  },
                  "unknownPeripherals": {
                    "type": ".squareup.connect.v2.ConnectedPeripheral",
                    "id": 5,
                    "rule": "repeated"
                  }
                }
              },
              "ConnectedPeripheral": {
                "fields": {
                  "uniqueIdentifier": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "deviceType": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "connectionType": {
                    "type": ".squareup.connect.v2.ConnectedPeripheral.ConnectionType",
                    "id": 3,
                    "rule": "optional"
                  },
                  "manufacturerName": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "modelName": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "ConnectionType": {
                    "values": {
                      "UNKNOWN": 0,
                      "NETWORK": 1,
                      "USB": 2,
                      "BLUETOOTH": 3,
                      "BLE": 4,
                      "AUDIO": 5,
                      "EMBEDDED": 6
                    }
                  }
                }
              },
              "CustomerDetails": {
                "fields": {
                  "customerInitiated": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "customerIp": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "sellerKeyedIn": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "PaymentProposalDetails": {
                "fields": {
                  "proposalId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "proposalVersion": {
                    "type": "int64",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "AsyncTransactionCreationDetails": {
                "fields": {
                  "type": {
                    "type": ".squareup.connect.v2.AsyncTransactionCreationDetails.Type",
                    "id": 1,
                    "rule": "optional"
                  },
                  "itemizationData": {
                    "type": ".squareup.connect.v2.ItemizationData",
                    "id": 2,
                    "rule": "optional"
                  },
                  "thirdPartyTerminalCreationDetails": {
                    "type": ".squareup.connect.v2.ThirdPartyTerminalCreationDetails",
                    "id": 3,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Type": {
                    "values": {
                      "UNKNOWN": 0,
                      "OPEN_BANKING": 1,
                      "PAYMENT_LINK": 2,
                      "THIRD_PARTY_TERMINAL": 3,
                      "LIGHTNING": 4
                    }
                  }
                }
              },
              "ThirdPartyTerminalCreationDetails": {
                "fields": {
                  "terminalId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "AdditionalSquareProductDetails": {
                "fields": {
                  "squareProduct": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "productReferenceId": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "Signal": {
                "fields": {
                  "name": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "value": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.CreatePaymentRequest && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.CreatePaymentResponse && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.UpdatePaymentRequest && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.UpdatePaymentResponse && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.CancelPaymentRequest && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.CancelPaymentResponse && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.CancelPaymentByIdempotencyKeyRequest && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.CancelPaymentByIdempotencyKeyResponse && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.SetEmvDataRequest && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.SetEmvDataResponse && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.CompletePaymentRequest && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.CompletePaymentResponse && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.CompletePaymentParamsForOrders && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.GetPaymentRequest && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.GetPaymentResponse && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.ListPaymentsRequest && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.ListPaymentsRequest?.nested?.SortField && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.ListPaymentsResponse && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.CardPresentOptions && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.GeoLocation && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.GeoLocation?.nested?.GeoLocationType && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.AuxiliaryInfo && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.CardPayInDetails && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.BillPayPullDetails && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.BillPayRecipientDetails && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.PeripheralMetadata && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.ConnectedPeripheral && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.ConnectedPeripheral?.nested?.ConnectionType && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.CustomerDetails && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.PaymentProposalDetails && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.AsyncTransactionCreationDetails && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.AsyncTransactionCreationDetails?.nested?.Type && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.ThirdPartyTerminalCreationDetails && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.AdditionalSquareProductDetails && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.Signal) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc Describes a request to create a payment using
 * [CreatePayment](api-endpoint:Payments-CreatePayment).
 * --
 *
 * SOURCE CreatePaymentRequest @ squareup/pago/external/payments_api.proto at 27:1
 */
export const CreatePaymentRequest = $root.lookupType('squareup.connect.v2.CreatePaymentRequest');
fixType(CreatePaymentRequest, {
  sourceId: {
    notEmpty: true
  },
  idempotencyKey: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(CreatePaymentRequest);
/**
 * --
 * @desc Defines the response returned by [CreatePayment](api-endpoint:Payments-CreatePayment).
 *
 * If there are errors processing the request, the `payment` field might not be
 * present, or it might be present with a status of `FAILED`.
 * --
 *
 * SOURCE CreatePaymentResponse @ squareup/pago/external/payments_api.proto at 589:1
 */
export const CreatePaymentResponse = $root.lookupType('squareup.connect.v2.CreatePaymentResponse');
fixType(CreatePaymentResponse);
Builder.createAndAttachToType(CreatePaymentResponse);
/**
 * --
 * @desc Describes a request to update a payment using
 * [UpdatePayment](api-endpoint:Payments-UpdatePayment).
 * --
 *
 * SOURCE UpdatePaymentRequest @ squareup/pago/external/payments_api.proto at 611:1
 */
export const UpdatePaymentRequest = $root.lookupType('squareup.connect.v2.UpdatePaymentRequest');
fixType(UpdatePaymentRequest, {
  idempotencyKey: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(UpdatePaymentRequest);
/**
 * --
 * @desc Defines the response returned by
 * [UpdatePayment](api-endpoint:Payments-UpdatePayment).
 * --
 *
 * SOURCE UpdatePaymentResponse @ squareup/pago/external/payments_api.proto at 646:1
 */
export const UpdatePaymentResponse = $root.lookupType('squareup.connect.v2.UpdatePaymentResponse');
fixType(UpdatePaymentResponse);
Builder.createAndAttachToType(UpdatePaymentResponse);
/**
 * --
 * @desc Describes the request to cancel (void) a payment using
 * [CancelPayment](api-endpoint:Payments-CancelPayment).
 * You can only cancel a payment that is approved (not completed).
 * For more information, see
 * [Delayed capture of a payment](https://developer.squareup.com/docs/payments-api/take-payments/card-payments#delayed-capture-of-a-card-payment).
 * --
 *
 * SOURCE CancelPaymentRequest @ squareup/pago/external/payments_api.proto at 664:1
 */
export const CancelPaymentRequest = $root.lookupType('squareup.connect.v2.CancelPaymentRequest');
fixType(CancelPaymentRequest);
Builder.createAndAttachToType(CancelPaymentRequest);
/**
 * --
 * @desc Defines the response returned by [CancelPayment](api-endpoint:Payments-CancelPayment).
 * --
 *
 * SOURCE CancelPaymentResponse @ squareup/pago/external/payments_api.proto at 677:1
 */
export const CancelPaymentResponse = $root.lookupType('squareup.connect.v2.CancelPaymentResponse');
fixType(CancelPaymentResponse);
Builder.createAndAttachToType(CancelPaymentResponse);
/**
 * --
 * @desc Describes a request to cancel a payment using
 * [CancelPaymentByIdempotencyKey](api-endpoint:Payments-CancelPaymentByIdempotencyKey).
 * --
 *
 * SOURCE CancelPaymentByIdempotencyKeyRequest @ squareup/pago/external/payments_api.proto at 694:1
 */
export const CancelPaymentByIdempotencyKeyRequest = $root.lookupType('squareup.connect.v2.CancelPaymentByIdempotencyKeyRequest');
fixType(CancelPaymentByIdempotencyKeyRequest, {
  idempotencyKey: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(CancelPaymentByIdempotencyKeyRequest);
/**
 * --
 * @desc Defines the response returned by
 * [CancelPaymentByIdempotencyKey](api-endpoint:Payments-CancelPaymentByIdempotencyKey).
 * On success, `errors` is empty.
 * --
 *
 * SOURCE CancelPaymentByIdempotencyKeyResponse @ squareup/pago/external/payments_api.proto at 710:1
 */
export const CancelPaymentByIdempotencyKeyResponse = $root.lookupType('squareup.connect.v2.CancelPaymentByIdempotencyKeyResponse');
fixType(CancelPaymentByIdempotencyKeyResponse);
Builder.createAndAttachToType(CancelPaymentByIdempotencyKeyResponse);
/**
 * --
 * @desc Adds EMV Data to a payment.
 *
 * The payment must have had `autocomplete` set to `false` when it was created and
 * must not yet be completed.
 * --
 *
 * SOURCE SetEmvDataRequest @ squareup/pago/external/payments_api.proto at 724:1
 */
export const SetEmvDataRequest = $root.lookupType('squareup.connect.v2.SetEmvDataRequest');
fixType(SetEmvDataRequest, {
  paymentId: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(SetEmvDataRequest);
/**
 * --
 * @desc The return value from the [SetEmvData][#endpint-payments-setemvdata) endpoint.
 * --
 *
 * SOURCE SetEmvDataResponse @ squareup/pago/external/payments_api.proto at 758:1
 */
export const SetEmvDataResponse = $root.lookupType('squareup.connect.v2.SetEmvDataResponse');
fixType(SetEmvDataResponse);
Builder.createAndAttachToType(SetEmvDataResponse);
/**
 * --
 * @desc Describes a request to complete (capture) a payment using
 * [CompletePayment](api-endpoint:Payments-CompletePayment).
 *
 * By default, payments are set to `autocomplete` immediately after they are created.
 * To complete payments manually, set `autocomplete` to `false`.
 * --
 *
 * SOURCE CompletePaymentRequest @ squareup/pago/external/payments_api.proto at 775:1
 */
export const CompletePaymentRequest = $root.lookupType('squareup.connect.v2.CompletePaymentRequest');
fixType(CompletePaymentRequest, {
  paymentId: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(CompletePaymentRequest);
/**
 * --
 * @desc Defines the response returned by[CompletePayment](api-endpoint:Payments-CompletePayment).
 * --
 *
 * SOURCE CompletePaymentResponse @ squareup/pago/external/payments_api.proto at 814:1
 */
export const CompletePaymentResponse = $root.lookupType('squareup.connect.v2.CompletePaymentResponse');
fixType(CompletePaymentResponse);
Builder.createAndAttachToType(CompletePaymentResponse);
/**
 * --
 * @desc Parameters to pass to Orders when completing a payment.
 *
 * We need these parameters in CompletePaymentRequest because it's one of the entry points to Order
 * closure.
 *
 * This is us:
 * 1. acknowledging the existing coupling between pago and orders and
 * 2. rolling out new behavior (gated by these parameters) to hopefully decouple them.
 * --
 *
 * SOURCE CompletePaymentParamsForOrders @ squareup/pago/external/payments_api.proto at 835:1
 */
export const CompletePaymentParamsForOrders = $root.lookupType('squareup.connect.v2.CompletePaymentParamsForOrders');
fixType(CompletePaymentParamsForOrders);
Builder.createAndAttachToType(CompletePaymentParamsForOrders);
/**
 * --
 * @desc Describes a request to retrieve a payment using
 * [GetPayment](api-endpoint:Payments-GetPayment).
 * --
 *
 * SOURCE GetPaymentRequest @ squareup/pago/external/payments_api.proto at 854:1
 */
export const GetPaymentRequest = $root.lookupType('squareup.connect.v2.GetPaymentRequest');
fixType(GetPaymentRequest);
Builder.createAndAttachToType(GetPaymentRequest);
/**
 * --
 * @desc Defines the response returned by [GetPayment](api-endpoint:Payments-GetPayment).
 * --
 *
 * SOURCE GetPaymentResponse @ squareup/pago/external/payments_api.proto at 865:1
 */
export const GetPaymentResponse = $root.lookupType('squareup.connect.v2.GetPaymentResponse');
fixType(GetPaymentResponse);
Builder.createAndAttachToType(GetPaymentResponse);
/**
 * --
 * @desc Describes a request to list payments using
 * [ListPayments](api-endpoint:Payments-ListPayments).
 *
 * The maximum results per page is 100.
 * --
 *
 * SOURCE ListPaymentsRequest @ squareup/pago/external/payments_api.proto at 882:1
 */
export const ListPaymentsRequest = $root.lookupType('squareup.connect.v2.ListPaymentsRequest');
fixType(ListPaymentsRequest);
Builder.createAndAttachToType(ListPaymentsRequest);
/**
 * SOURCE SortField @ squareup/pago/external/payments_api.proto at 987:3
 */
ListPaymentsRequest.SortField = $root.lookupEnum('squareup.connect.v2.ListPaymentsRequest.SortField').values;
/**
 * --
 * @desc Defines the response returned by [ListPayments](api-endpoint:Payments-ListPayments).
 * --
 *
 * SOURCE ListPaymentsResponse @ squareup/pago/external/payments_api.proto at 1004:1
 */
export const ListPaymentsResponse = $root.lookupType('squareup.connect.v2.ListPaymentsResponse');
fixType(ListPaymentsResponse);
Builder.createAndAttachToType(ListPaymentsResponse);
/**
 * --
 * @desc Information about a card-present payment. It can be used to determine the acceptable
 * methods available for taking certain kinds of payments, such as swiped cards when an EMV
 * reader is present or for offline payments.
 * --
 *
 * SOURCE CardPresentOptions @ squareup/pago/external/payments_api.proto at 1128:1
 */
export const CardPresentOptions = $root.lookupType('squareup.connect.v2.CardPresentOptions');
fixType(CardPresentOptions);
Builder.createAndAttachToType(CardPresentOptions);
/**
 * --
 * @desc Represents the geolocation of the physical device.
 * --
 *
 * SOURCE GeoLocation @ squareup/pago/external/payments_api.proto at 1162:1
 */
export const GeoLocation = $root.lookupType('squareup.connect.v2.GeoLocation');
fixType(GeoLocation);
Builder.createAndAttachToType(GeoLocation);
/**
 * --
 * @desc Type of method used to determine the geolocation.
 * --
 *
 * SOURCE GeoLocationType @ squareup/pago/external/payments_api.proto at 1189:3
 */
GeoLocation.GeoLocationType = $root.lookupEnum('squareup.connect.v2.GeoLocation.GeoLocationType').values;
/**
 * --
 * @desc A generic key-value pair that contains auxiliary information about the payment.
 * --
 *
 * SOURCE AuxiliaryInfo @ squareup/pago/external/payments_api.proto at 1205:1
 */
export const AuxiliaryInfo = $root.lookupType('squareup.connect.v2.AuxiliaryInfo');
fixType(AuxiliaryInfo);
Builder.createAndAttachToType(AuxiliaryInfo);
/**
 * --
 * @desc Details required for creating a card PayIn pull payment.
 * Intended for internal use only.
 * --
 *
 * SOURCE CardPayInDetails @ squareup/pago/external/payments_api.proto at 1216:1
 */
export const CardPayInDetails = $root.lookupType('squareup.connect.v2.CardPayInDetails');
fixType(CardPayInDetails);
Builder.createAndAttachToType(CardPayInDetails);
/**
 * --
 * @desc Details required for creating a BillPay pull payment.
 * Intended for internal use only.
 * --
 *
 * SOURCE BillPayPullDetails @ squareup/pago/external/payments_api.proto at 1278:1
 */
export const BillPayPullDetails = $root.lookupType('squareup.connect.v2.BillPayPullDetails');
fixType(BillPayPullDetails);
Builder.createAndAttachToType(BillPayPullDetails);
/**
 * --
 * @desc Contains details about the recipient of a bill pay payment.
 * This includes information about the individual or entity that Square will pay the bill to
 * on behalf of the initiating merchant.
 * --
 *
 * SOURCE BillPayRecipientDetails @ squareup/pago/external/payments_api.proto at 1334:1
 */
export const BillPayRecipientDetails = $root.lookupType('squareup.connect.v2.BillPayRecipientDetails');
fixType(BillPayRecipientDetails);
Builder.createAndAttachToType(BillPayRecipientDetails);
/**
 * --
 * @desc Information about system state and connected peripherals when taking a payment.
 * --
 *
 * SOURCE PeripheralMetadata @ squareup/pago/external/payments_api.proto at 1365:1
 */
export const PeripheralMetadata = $root.lookupType('squareup.connect.v2.PeripheralMetadata');
fixType(PeripheralMetadata);
Builder.createAndAttachToType(PeripheralMetadata);
/**
 * --
 * @desc Contains identifying information about a peripheral present when taking a payment.
 * --
 *
 * SOURCE ConnectedPeripheral @ squareup/pago/external/payments_api.proto at 1400:1
 */
export const ConnectedPeripheral = $root.lookupType('squareup.connect.v2.ConnectedPeripheral');
fixType(ConnectedPeripheral);
Builder.createAndAttachToType(ConnectedPeripheral);
/**
 * --
 * @desc The enumeration of different ways a peripheral might be connected.
 * --
 *
 * SOURCE ConnectionType @ squareup/pago/external/payments_api.proto at 1406:3
 */
ConnectedPeripheral.ConnectionType = $root.lookupEnum('squareup.connect.v2.ConnectedPeripheral.ConnectionType').values;
/**
 * --
 * @desc Details about the customer making the payment.
 * --
 *
 * SOURCE CustomerDetails @ squareup/pago/external/payments_api.proto at 1472:1
 */
export const CustomerDetails = $root.lookupType('squareup.connect.v2.CustomerDetails');
fixType(CustomerDetails);
Builder.createAndAttachToType(CustomerDetails);
/**
 * --
 * @desc Details for creating a payment using a PaymentProposal.
 * --
 *
 * SOURCE PaymentProposalDetails @ squareup/pago/external/payments_api.proto at 1494:1
 */
export const PaymentProposalDetails = $root.lookupType('squareup.connect.v2.PaymentProposalDetails');
fixType(PaymentProposalDetails);
Builder.createAndAttachToType(PaymentProposalDetails);
/**
 * --
 * @desc Details for creating a payment with `source_id` `ASYNC_TRANSACTION`.
 * --
 *
 * SOURCE AsyncTransactionCreationDetails @ squareup/pago/external/payments_api.proto at 1516:1
 */
export const AsyncTransactionCreationDetails = $root.lookupType('squareup.connect.v2.AsyncTransactionCreationDetails');
fixType(AsyncTransactionCreationDetails);
Builder.createAndAttachToType(AsyncTransactionCreationDetails);
/**
 * --
 * @desc Types of Asynchronous payments.
 * --
 *
 * SOURCE Type @ squareup/pago/external/payments_api.proto at 1522:3
 */
AsyncTransactionCreationDetails.Type = $root.lookupEnum('squareup.connect.v2.AsyncTransactionCreationDetails.Type').values;
/**
 * SOURCE ThirdPartyTerminalCreationDetails @ squareup/pago/external/payments_api.proto at 1558:1
 */
export const ThirdPartyTerminalCreationDetails = $root.lookupType('squareup.connect.v2.ThirdPartyTerminalCreationDetails');
fixType(ThirdPartyTerminalCreationDetails);
Builder.createAndAttachToType(ThirdPartyTerminalCreationDetails);
/**
 * --
 * @desc Contains internally used details about a SquareProduct associated with a payment. This does
 * not necessarily have to be the same SquareProduct as the top level square_product field and there
 * can be any additional number of AdditionalSquareProductDetails associated with a payment. Only
 * first party Square clients are expected to set this field.
 * --
 *
 * SOURCE AdditionalSquareProductDetails @ squareup/pago/external/payments_api.proto at 1573:1
 */
export const AdditionalSquareProductDetails = $root.lookupType('squareup.connect.v2.AdditionalSquareProductDetails');
fixType(AdditionalSquareProductDetails);
Builder.createAndAttachToType(AdditionalSquareProductDetails);
/**
 * --
 * @desc Represents a custom signal provided by the payment creator and shared
 * with Risk systems when conducting risk assessments. This information is not
 * read or interpreted by the Payment stack, only passed along to Risk.
 * --
 *
 * SOURCE Signal @ squareup/pago/external/payments_api.proto at 1595:1
 */
export const Signal = $root.lookupType('squareup.connect.v2.Signal');
fixType(Signal, {
  name: {
    notEmpty: true
  },
  value: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(Signal);